<a
  panButton
  [width]="200"
  [color]="locationProfileStatusColor(params.data.profile.status)"
  [routerLink]="['/home', 'manage', 'branch', params.branchId(), 'location', params.data.id]"
  [queryParams]="{ subpage: 'profile' }"
>
  @if (params.data.profile.status === "InProgress") {
    {{ params.data.profile.completion_percentage | number: "1.0-0" }}% Complete
  } @else {
    {{ params.data.profile.status }}
  }
</a>
